import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Homepage from "./page/home";
import CategoryPage from "./page/category";
import { Provider, useSelector } from 'react-redux';
import store from './redux/store';
import CartPage from "./component/cart";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from './component/loadingSpinner';
import AOS from 'aos';
import WishlistPage from "./component/wishlist";
import CartWish from './component/cartWishlistNavigate';
import ProductDetail from "./page/productDetail";
import AllProductsList from "./component/Allproductlist";
import WeekDeal from "./component/weekDeal";
import ControlledTabs from "./component/allProductsList";
import Compare from "./page/compare";
import ProductCategory from "./page/productCategory";
import TodaysDeals from './component/todaysDeals';

function App() {
  // const isLoading = useSelector((state) => state.loading.isLoading);
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, [])
  useEffect(() => {
    document.title = "Your Store";
  }, []);
  
  return (
    <>
    <Provider store={store}>
    <Router>
      
    {/* {isLoading && <LoadingSpinner />} */}
      <Routes>
    
     
        <Route path="/" element={<Homepage />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/category" element={<CategoryPage />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/productCategory" element={<ProductCategory />} />
        <Route path="/todays-deals"  element={<TodaysDeals />} />
        {/* <Route path="/cart" element={<CartPage />} />
        <Route path="/wishlist" element={<WishlistPage />} /> */}
      </Routes>
      <CartWish />
     </Router>
      </Provider>
      <ToastContainer />
    </>
  );
}

export default App;
